<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <input type="text" style="display:none">
      <el-form-item label="(源)批次包" v-if="show('code')">
        <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="输入源批次包"
          @keydown.native.enter="emitSearch"></el-input>
      </el-form-item>
      <el-form-item label="(新)批次包" v-if="show('code_new')">
        <el-input maxlength='450' v-model="formInline.pkgCodeNew" placeholder="输入新批次包"
          @keydown.native.enter="emitSearch"></el-input>
      </el-form-item>
      <el-form-item label="物流单号" v-if="show('expNo')">
        <el-input maxlength='450' placeholder="输入物流单号" v-model="formInline.expressNo"
          style="width:140px;margin-left:20px;" @keydown.native.enter="emitSearch"></el-input>
      </el-form-item>
      <el-form-item label="入库单号" v-if="show('inboundCode')">
        <el-input maxlength='50' placeholder="输入入库单号" v-model="formInline.inboundCode" style="width:160px;"
          @keydown.native.enter="emitSearch"></el-input>
      </el-form-item>
      <el-form-item label="时间" v-if="show('date')">
        <el-date-picker v-model="date" :default-time="['', '23:59:59']" type="datetimerange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="业务处理状态" v-if="show('business')">
        <el-select placeholder="全部" v-model="formInline.serviceStatus">
          <el-option label="全部" value=""></el-option>
          <el-option label="未处理" value="0"></el-option>
          <el-option label="已处理" value="1"></el-option>
          <el-option label="处理中" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="仓库处理状态" v-if="show('warehouse')">
        <el-select placeholder="全部" v-model="formInline.wareStatus" style="width:100px;">
          <el-option label="全部" value=""></el-option>
          <el-option label="未处理" value="0"></el-option>
          <el-option label="已处理" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="异常状态" v-if="show('error')">
        <el-select placeholder="全部" v-model="formInline.abnormalType">
          <el-option :label="item.label" :value="item.value" v-for="item in pkgTypeLIst" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单来源" v-if="show('systemSource')">
        <el-select placeholder="全部" v-model="formInline.systemSource">
          <el-option label="全部" value=""></el-option>
          <el-option label="B2B" value="2"></el-option>
          <el-option label="D2C" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="异常来源" v-if="show('exceptionSource')">
        <el-select placeholder="全部" v-model="formInline.exceptionSource">
          <el-option label="全部" value=""></el-option>
          <el-option label="简单检品" value="1"></el-option>
          <el-option label="详细检品" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="异常类型" v-if="show('exceptionCodes')">
        <el-select placeholder="全部" v-model="formInline.exceptionCodes" filterable multiple>
          <!-- <el-option label="全部" value=""></el-option> -->
          <el-option :label="i.title" :value="Number(i.value)" v-for="i in abnormalClient"></el-option>
          <el-option :label="i.title" :value="Number(i.value)" v-for="i in abnormalPurchase_inHouse"></el-option>
          <el-option :label="i.title" :value="Number(i.value)" v-for="i in abnormalDefective"></el-option>
          <!-- <el-option label="少件到货" :value="105" ></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="客户ID">
        <el-input maxlength='20' v-model.number="formInline.customerId"
          @input="formInline.customerId = formInline.customerId.replace(/\D/g, '')" placeholder="输入客户ID"></el-input>
      </el-form-item>
      <!-- <el-form-item label="少件到货" v-if="show('isShortage')">
        <el-select placeholder="全部" v-model="formInline.isShortage">
          <el-option label="全部" value=""></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="emitSearch()">查询</el-button>
        <el-button style="margin-left: 10px" @click="rest()">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { abnormalClient, abnormalDefective, abnormalPurchase_inHouse } from '@/types/index'
export default {
  name: "Form",
  data() {
    return {
      formInline: {},
      pkgTypeLIst: [
        {
          value: '',
          label: "全部",
        },
        {
          value: 0,
          label: "少件",
        },
        {
          value: 1,
          label: "多件",
        },
      ],
      date: null,
      abnormalClient, abnormalDefective, abnormalPurchase_inHouse
    };
  },
  props: {
    layout: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$emit("search", this.formInline);
  },
  methods: {
    show(Str) {
      return !!this.layout.split(',').find(v => v.trim() === Str)
    },
    rest: function () {
      this.formInline = {};
      this.date = null;
      this.$emit("search", this.formInline);
    },
    emitSearch() {
      let params = { ...this.formInline };
      if (this.date) {
        params.createTimeBegine = formatDate(this.date[0].getTime());
        params.createTimeEnd = formatDate(this.date[1].getTime());
      }
      this.$emit("search", params);


      function formatDate(value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      };
    },
    // dateChange: function (date) {
    //   if (!date) {
    //     this.formInline.createStartTime = null
    //     this.formInline.createEndTime = null
    //     return
    //   }
    //   this.formInline.createStartTime = date[0].getTime();
    //   this.formInline.createEndTime = date[1].getTime();
    //   this.$emit('search', this.formInline)
    // }
  },
};
</script>

<style scoped></style>
